module.exports = __webpack_public_path__ + "static/media/confirm-inquiry.a1337351.svg";